export default __webpack_public_path__ + "static/media/GIRLS.5747d686.jpg";